import { useTranslation } from 'react-i18next'

import { Tooltip } from '@percent/lemonade'
import { ReactComponent as DefaultStarIcon } from '@percent/partner-dashboard/common/assets/images/default-star.svg'

export function DefaultStar() {
  const { t } = useTranslation()

  return (
    <Tooltip content={t('typography.templates.defaultBadge')}>
      <span data-testid="default-star">
        <DefaultStarIcon />
      </span>
    </Tooltip>
  )
}
